import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addLineBreaks } from "../actions/tool";
import LeftMenuTree from "./containers/LeftMenuTree";
import "./SideScreen.css";
import UserProfile from "./UserProfile";

const StyledBadge = withStyles((theme) => ({
	badge: {
		backgroundColor: "#44b700",
		color: "#44b700",
		boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
		"&::after": {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			borderRadius: "50%",
			animation: "$ripple 1.2s infinite ease-in-out",
			border: "1px solid currentColor",
			content: '""',
		},
	},
	"@keyframes ripple": {
		"0%": {
			transform: "scale(.8)",
			opacity: 1,
		},
		"100%": {
			transform: "scale(2.4)",
			opacity: 0,
		},
	},
}))(Badge);

const SmallAvatar = withStyles((theme) => ({
	root: {
		width: 22,
		height: 22,
		border: `2px solid ${theme.palette.background.paper}`,
	},
}))(Avatar);

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		"& > *": {
			margin: theme.spacing(1),
		},
	},
}));

export const LeftSideScreen = (props) => {
	const ref = useRef(null);

	const [firstload, setFirstload] = React.useState(true);
	const dispatch = useDispatch();
	const state = useSelector((state) => state);

	const [open, setOpen] = React.useState(false);
	let image;
	let buffer;
	try {
		buffer = Buffer.from(state.auth.user.image.data);
		image = "data:image/png;base64," + buffer.toString("base64");
	} catch (e) {}

	const [imageSrc, setImageSrc] = React.useState(image);
	let imageltvar;
	let usernameV;
	try {
		imageltvar = state.auth.user.allUser.find(
			(y) => y._id === state.auth.user.usernameId
		).username;
		usernameV = state.auth.user.allUser.find(
			(y) => y._id === state.auth.user.usernameId
		).name;
	} catch (e) {}

	const [imageAlt, setImageAlt] = React.useState(imageltvar);
	const [name, setName] = React.useState(usernameV);
	const [office_name, setOffice_name] = React.useState(imageltvar);

	const [photo, setPhoto] = React.useState(image);
	let newStatus = {};

	try {
		newStatus =
			state.userStatus.status.statusMoreInfo[
				state.userStatus.status.statusMoreInfo.length - 1
			];
	} catch (e) {
		newStatus = {};
	}
	const [status, setStatus] = React.useState(newStatus);

	let statusDetails = {};
	try {
		if (status.status)
			statusDetails = state.auth.user.settings[0].userStatus.find(
				(x) => x.id === status.status
			);
	} catch (e) {}
	React.useEffect(() => {
		try {
			if (!status.status) {
				setStatus(
					state.userStatus.status.statusMoreInfo[
						state.userStatus.status.statusMoreInfo.length - 1
					]
				);
			}
		} catch (e) {}
	});

	//console.log("props.imageSrc=", props.imageSrc);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	const showProfile = () => {
		handleClickOpen();
	};
	const handlesaveProfile = () => {};

	const setnewProfilePictureFx = (value) => {
		console.log("setnewProfilePicture SideScreen value=", value);
		console.log("setnewProfilePicture  ref.current =", ref.current);
		try {
			setStatus(ref.current.status);
		} catch (e) {}
		try {
			setPhoto(ref.current.photo);
		} catch (e) {}

		//props.setnewProfilePicture(value);
	};

	React.useEffect(() => {
		var aside = document.querySelector(".side-nav");
		var showAsideBtn = document.querySelector(".show-side-btn");
		var contents = document.querySelector("#contents");
		console.log("window=", window);

		try {
			document
				.querySelector(".side-nav .close-aside")
				.addEventListener("click", function () {
					console.log("Dashboard this.dataset.close=", this.dataset.close);
					document
						.querySelector("#" + this.dataset.close)
						.classList.add("show-side-nav");

					contents.classList.add("margin");
				});
		} catch (d) {}
		if (window.innerWidth <= 767) {
			try {
				console.log("window.innerWidth <= 767=", window.innerWidth);
				aside.classList.add("show-side-nav");
				contents.classList.add("margin");
			} catch (e) {
				console.error("window.innerWidth <= 767 error=", e);
			}
		}
		if (window.innerWidth > 767) {
			try {
				console.log("window.innerWidth > 767=", window.innerWidth);
				//contents.classList.remove("margin");
				//.classList.remove("show-side-nav");
			} catch (e) {
				console.error("window.innerWidth <= 767 error=", e);
			}
		}

		window.addEventListener("resize", function () {
			console.log("window resize window.innerWidth=", window.innerWidth);
			if (window.innerWidth <= 767) {
				try {
					console.log("window.innerWidth <= 767=", window.innerWidth);
					aside.classList.add("show-side-nav");
					contents.classList.add("margin");
				} catch (e) {
					console.error("window.innerWidth <= 767 error=", e);
				}
			}
			if (window.innerWidth > 767) {
				try {
					console.log("window.innerWidth > 767=", window.innerWidth);
					//contents.classList.remove("margin");
					//.classList.remove("show-side-nav");
				} catch (e) {
					console.error("window.innerWidth <= 767 error=", e);
				}
			}
		});
	});

	useEffect(() => {
		let content = "";
		if (state.auth) {
			console.log("props.auth=", props.auth);
			var buffer;
			try {
				buffer = Buffer.from(state.auth.user.image.data);
				document.getElementById(
					"username"
				).innerHTML = state.auth.user.allUser.find(
					(y) => y._id === state.auth.user.usernameId
				).name;
				setImageSrc("data:image/png;base64," + buffer.toString("base64"));
				setImageAlt(
					state.auth.user.allUser.find(
						(y) => y._id === state.auth.user.usernameId
					).username
				);
			} catch (e) {
				console.error("Dashboard error=", e);
			}
			try {
				content = "-" + state.auth.user.office[0].office_name;
			} catch (e) {}
			//document.getElementById("profilePicture").src ="data:image/png;base64," + buffer.toString("base64");
		}

		if (state.userStatus) {
			try {
				console.log(
					"DashBoard state.userStatus.status.actingOffice=",
					state.userStatus.status.actingOffice
				);
				state.userStatus.status.actingOffice
					.filter((x) => new Date(x.toDate) >= new Date() && !x.cancelled)
					.map((y) => {
						content +=
							"\r\n - Acting as " +
							state.auth.user.allOffices.find(
								(z) => z.office_id === y.officeActingOnBehalf
							).office_name +
							" to " +
							new Date(y.toDate);
					});
			} catch (e) {
				console.error("Dashboard state=", state);
				console.error("Dashboard error in seting profile office=", e);
			}
		}
		//document.getElementById("office_name").innerHTML = content;
		setOffice_name(content);
	}, [state.userStatus]);
	return (
		<aside className="side-nav" id="show-side-navigation1">
			<i
				className="fa fa-close close-aside hidden-sm hidden-md hidden-lg"
				data-close="show-side-navigation1"
			/>
			<div className="heading">
				<StyledBadge
					overlap="circle"
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "right",
					}}
					variant="dot"
					onClick={showProfile}
				>
					<Avatar alt={imageAlt} src={photo} />
				</StyledBadge>
				<div className="info">
					<h3>
						<a>
							<div id="username">{name}</div>
						</a>
					</h3>
					<p id="office_name">{addLineBreaks(office_name)}</p>
				</div>
			</div>
			<ul className="categories">
				<li>
					<Box color="text.primary">
						<LeftMenuTree
							openEditing={props.openEditing}
							openAllDocs={props.openAllDocs}
							showAllDocs={props.showAllDocs}
							showDraftDocs={props.showDraftDocs}
							showTrashDocs={props.showTrashDocs}
							showDocumentTable={props.showDocumentTable}
						/>
					</Box>
				</li>
			</ul>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">Profile</DialogTitle>
				<DialogContent>
					<DialogContentText>Profile</DialogContentText>
					<div style={{ width: 600 }}>
						<UserProfile
							photo={photo}
							setStatus={setStatus}
							style={{ width: "100%" }}
							office_name={props.office_name}
							setnewProfilePictureFx={(value) => {
								console.log("setnewProfilePicture issued value=", value);
								setnewProfilePictureFx(value);
							}}
							ref={ref}
						/>
					</div>
					{status && (
						<div>
							<div className="profile-user-info">
								<div className="profile-info-row">
									<div className="profile-info-name"> Status </div>

									<div className="profile-info-value">
										<span>{status ? statusDetails.action : ""}</span>
									</div>
								</div>
								<div className="profile-info-row">
									<div className="profile-info-name">Reason </div>

									<div className="profile-info-value">
										<span>{status ? statusDetails.description : ""}</span>
									</div>
								</div>
								<div className="profile-info-row">
									<div className="profile-info-name"> Period </div>

									<div className="profile-info-value">
										<span>
											{status
												? moment(status.fromDate).format("Do,MMM yyyy")
												: " "}
											{"  to  "}
											{status
												? moment(status.toDate).format("Do,MMM yyyy")
												: " "}
										</span>
									</div>
								</div>

								<div className="profile-info-row">
									<div className="profile-info-name"> Location </div>

									<div className="profile-info-value">
										<i className="fa fa-map-marker light-orange bigger-110"></i>
										<span>Rwanda</span>
										<span>Kigali</span>
									</div>
								</div>
							</div>
						</div>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Exit
					</Button>
				</DialogActions>
			</Dialog>
		</aside>
	);
};
